import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { CheckFilledCircleIcon, InfoFilledCircleIcon } from "@gemini/icons";
import { useSections } from "@/contexts/classified";
export const TotalCostInfoMessage = () => {
    var _a, _b, _c;
    const message = (_c = (_b = (_a = useSections()) === null || _a === void 0 ? void 0 : _a.price) === null || _b === void 0 ? void 0 : _b.breakdown) === null || _c === void 0 ? void 0 : _c.message;
    if (!message)
        return null;
    const isSuccess = message.type === "SUCCESS";
    return (_jsxs(Box, { display: "flex", alignItems: "center", backgroundColor: isSuccess
            ? "color.surface.status.success.default"
            : "color.surface.status.information.default", typography: "typography.body.14.regular", borderRadius: "radius.rounded", paddingLeft: "spacing.8", paddingRight: "spacing.12", paddingVertical: "spacing.6", width: "fit-content", marginBottom: "spacing.16", gap: "spacing.4", children: [isSuccess ? (_jsx(CheckFilledCircleIcon, { size: "sizing.24", color: "color.border.status.success.default" })) : (_jsx(InfoFilledCircleIcon, { size: "sizing.24", color: "color.border.status.information.default" })), message.value] }));
};
